/* eslint-disable no-unused-vars */

import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import style from './style.module.scss';
import Icon from '@components/icon-component';
import useWindowDimensions from '@hooks/useWindowDimensions';
import Collapseable from '@components/collapseable';
import DataSnippets from '@components/data-snippet';

const PSVsContainer = ({
  moreInfoOfPSVs,
  errors,
  setOpenAddPsvModalEvent,
  vesselEquipmentId,
  openAttachOrReattachModalEvent,
  onClickOpliiDesktopLinkEvent
}) => {
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  const editPSVEvent = ({ equipmentId, equipmentEditingStatus }) => {
    const isVesselUpdated =
      localStorage.getItem('equipmentDetailsUpdated') === vesselEquipmentId ? 'true' : 'false';

    const isOnlyPSVDataUpdatedForVessel = localStorage.getItem('onlyPSVDataUpdatedForVessel')
      ? 'true'
      : 'false';

    const isOnlyPSVDataUpdatedForVesselId =
      localStorage.getItem('onlyPSVDataUpdatedForVessel') || null;

    let url = equipmentEditingStatus
      ? `/add-edit-equipment?equipmentId=${equipmentId}&title=Edit PSV&vesselEquipmentId=${vesselEquipmentId}&hideDiscardBtn=true&isVesselUpdated=${isVesselUpdated}&isOnlyPSVDataUpdatedForVessel=${isOnlyPSVDataUpdatedForVessel}`
      : `/add-edit-equipment?equipmentId=${equipmentId}&title=Edit PSV&vesselEquipmentId=${vesselEquipmentId}&isVesselUpdated=${isVesselUpdated}&isOnlyPSVDataUpdatedForVessel=${isOnlyPSVDataUpdatedForVessel}`;

    if (isOnlyPSVDataUpdatedForVesselId) {
      url = `${url}&isOnlyPSVDataUpdatedForVesselId=${localStorage
        .getItem('onlyPSVDataUpdatedForVessel')
        .toString()}`;
    }

    navigate(url);
  };

  const headerWidth = useMemo(() => {
    let mainCOntainerWidth = document.getElementById('add-edit-equipment-body')?.clientWidth || 0;
    return mainCOntainerWidth
      ? width > 500
        ? mainCOntainerWidth / 2 - 32
        : mainCOntainerWidth - 32
      : 0;
  }, [document.getElementById('add-edit-equipment-body'), width]);

  return (
    <div className={style.PSVsContainer}>
      <div className={style.grid2ForPSVs}>
        {moreInfoOfPSVs?.map((psvs) => {
          return (
            <div
              key={psvs?.id}
              id={psvs?.id}
              style={
                {
                  // width: `100%`
                  // minWidth: `${headerWidth}px`
                }
              }
            >
              <Collapseable
                title={psvs?.name || ''}
                subTitle={
                  (psvs?.equipmentEditingStatus || psvs?.isLinkToExistingPSV) &&
                  psvs?.verificationStatus
                    ? psvs?.verificationStatus
                    : ''
                }
                subTitleClass={style.psvsSubTitle}
                subTitleErrorClass={style.psvsSubTitleError}
                dot={psvs?.verificationStatus ? true : false}
                noAction={true}
                openCollapse={psvs?.expand || false}
                headerWidth={headerWidth}
                dotColor="#34C369"
              >
                <>
                  <DataSnippets
                    title={psvs.title || ''}
                    subtitle={psvs?.name || ''}
                    dataPoints={psvs.dataPoints || []}
                    subTitleClassName={style.subTitleClassName}
                    // link={psvs.link}
                    link={`/equipment-details/${psvs?.id}`}
                    onClickOpliiDesktopLinkEvent={onClickOpliiDesktopLinkEvent}
                  />
                  <div className={style.action}>
                    <Icon
                      name={psvs?.isDetached ? 'de-attached' : 'attached'}
                      alt=""
                      style={{ marginRight: '48px', cursor: 'pointer' }}
                      onClick={() => {
                        openAttachOrReattachModalEvent({
                          isDetached: psvs?.isDetached,
                          equipmentId: psvs?.id
                        });
                      }}
                    />

                    <button
                      type="button"
                      onClick={() => {
                        editPSVEvent({
                          equipmentId: psvs.id,
                          equipmentEditingStatus: psvs?.equipmentEditingStatus
                        });
                      }}
                    >
                      <span>
                        {' '}
                        <Icon name={'edit-pencil'} /> Edit
                      </span>
                    </button>
                  </div>
                </>
              </Collapseable>
            </div>
          );
        })}
      </div>
      <p
        className={style.addPSVs}
        style={{
          marginTop: moreInfoOfPSVs?.length > 0 ? '16px' : '0px',
          width: '92px'
        }}
        onClick={setOpenAddPsvModalEvent}
      >
        <Icon name={'add-icon'} style={{ marginRight: '4px' }} />
        Add PSV
      </p>
    </div>
  );
};

export default PSVsContainer;
